import { useEffect, useMemo, useRef, useState } from 'react';
import { ChangeAlertCallbackType } from '../../../Root';
import { CrmService } from '../../../../services/CrmService';

import moment from 'moment';
moment.locale('es');

export const useCRMAddRegister = (changeAlert: ChangeAlertCallbackType, onClose: any, getLeadByUuid) => {
    const crmService = useRef<CrmService>();
    const [data, setData] = useState([]);
    const [store, setStore] = useState({});
    const [form, setForm] = useState({
        filters: {},
        pagination: {
            page_number: 1,
            results_per_page: 10,
        }
    });
    const [newRegister, setNewRegister] = useState({})
    const [zPos, setZPos] = useState(45);
    const agent = localStorage.session ? JSON.parse(localStorage.session) : {};
    const config = localStorage.config ? JSON.parse(localStorage.config) : {};

    const [error, setError] = useState("");
    const [isValid, setIsValid] = useState(true);
    const [isValidFilter, setIsValidFilter] = useState(true);
    const [loading, setLoading] = useState(true);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [tabActive, setTabActive] = useState('create');
    const [addPartner, setAddPartner] = useState('');
    const tabs = [
        { name: 'create', title: 'Crear' },
        { name: 'update', title: 'Agregar existente' },
    ];


    const saveData = async (result) => {
        let validate = Array.isArray(result?.content);
        setData(JSON.parse(JSON.stringify(validate ? result.content || [] : [result.content])));
        setTotalRows(result?.pagination?.total_documents || 0);
        setLoading(false)
    };

    const storeData = async (section, lead, crmType, platformData, platformInfo) => {
        let d = store;
        d['section'] = section;
        d['lead'] = lead;
        d['platform'] = crmType;
        d['platformData'] = platformData;
        d['platformInfo'] = platformInfo;
        setStore(d);
        setLoading(false);
        section !== "contact" ? 
        setNewRegister({
            ...newRegister,
            general: {
                gname: '', lname: '', email: '',
                phone: {phone: '', phone_code: '+52'},
            },
            app_uuid: '', origin_platform: '', status: '', crmContactFlow: config['crmOutbound'] ? 'crmOutbound' : 'crmInbound'
        })
        :
        setNewRegister({
            ...newRegister,
            general: {
                company_name: '', account_type: '', onboarding_email: '',
            },
            app_uuid: '', origin_platform: ''
        })
    };

    const getData = async (newPage, newPerPage = perPage, form) => {
        setLoading(true);
        let f = form;
       
        f['pagination'] = {page_number: newPage, results_per_page: newPerPage};

        let service = store['section'] === 'company' ? 'leadContactCrmFind' : 'leadCrmFind';

        const response = await crmService.current[service](f);
        if (response['data']?.response === 'OK') {
            setLoading(false);
            saveData(response.data['content'] ? response.data : response.data.widget.length > 0 ? response.data.widget[0].data : { content: [] });
        } else {
            setLoading(false);
            saveData({ content: [] });
            changeAlert(true, 'error', response['data'].message || 'Error al consultar servicio');
        }
        setPage(newPage);
    };

    const onCreate = async () => {
        setLoading(true);
        setZPos(1);

        let req = {data: newRegister}
        req['data']['agent'] = {
            uuid: agent['uuid'],
            email: agent['email'],
            name: agent['name']
        }
        
        let service = ''
        if(store['section'] === 'company'){
            service = 'leadContactCrmCreate'
            req['data']['partner_company'] = store['lead']['uuid'];
            req['data']['status'] = 'new';
        } else {
            service = 'leadCrmCreate'
            req["data"]["low_funnel"] = "opportunity";
            req['data']['partner_contact'] = store['lead']['uuid']
            req['data']['status'] = newRegister['result'] ? 'leftOnboarding' : 'lead';
        }

        const response = await crmService.current[service](req);
        if (response['data']?.response === 'OK') {
            setAddPartner(response['data']['content']['uuid'])
            setLoading(false);
            setZPos(45);
            onClose("created");
            getLeadByUuid(store['lead']['uuid'], store['section']);
        } else {
            setLoading(false);
            setZPos(45);
            onClose();
            changeAlert(true, 'error', response['message'] || response['data'].message || 'Error al consultar servicio');
        }
    };

    const onUpdate = async (partner = addPartner) => {
        setLoading(true);
        setZPos(1);

        let req = {
            data: {
                uuid: store['lead']['uuid']
            },
            agent: {
                uuid: agent['uuid'],
                email: agent['email'],
                name: agent['name']
            }
        };
        let service = ''
        if(store['section'] === 'company'){
            service = 'leadCrmAddContact'
            req['data']['partner_contact'] = partner
        } else {
            service = 'leadContactCrmAddLead'
            req['data']['partner_company'] = partner
        }

        const response = await crmService.current[service](req);
        if (response['data']?.response === 'OK') {
            setLoading(false);
            setZPos(45);
            changeAlert(true, 'success', 'El registro se creó con éxito');
            onClose();
            getLeadByUuid(store['lead']['uuid'], store['section']);
        } else {
            setLoading(false);
            setZPos(45);
            changeAlert(true, 'error', response['message'] || response['data'].message || 'Error al consultar servicio');
            onClose();
        }
    };

    const crmFilter = () => {
        getData(1, perPage, form);
    };
    
    const changeTab = (tab: string) => {
        setTabActive(tab);
    };

    const onHandleChange = (key1, key2, key3 = null, e) => {
        let f = newRegister;
        let value = e['target'] ? e['target']['value'] : e['props']['value'];

        if(key2.includes('email')){
            value = value.trim();
        }

        if(key3){
            f[key1] ?
                f[key1][key2]
                ?
                f[key1][key2][key3] = key3 === 'phone_code' ? `+${value}` : value
                :
                f[key1][key2] = {[key3]: key3 === 'phone_code' ? `+${value}` : value}
            :
            f[key1] = {[key2]: {[key3]: key3 === 'phone_code' ? `+${value}` : value}}

            if(!f[key1][key2]['phone_code']){
                f[key1][key2]['phone_code'] = '+52'
            }
        } else if(key2 && key1){
            let val = key1 === "revenue" ? Number(value) : value;
            f[key1] ? f[key1][key2] = val : f[key1] = {...newRegister[key1], [key2]: val}
        } else if(key1){
            f[key1] = value;
        } else if(!key1 && key2){
            f[key2] = value;
        }
        validateForm(f);
        setNewRegister(JSON.parse(JSON.stringify(f)));
    };

    const validateForm = (f) => {
        const allFieldsFilled = 
        Object.values(f.general).every((field) => {
            if (typeof field === 'object') {
                return Object.values(field).every((value) => String(value).trim() !== '');
            }
            return String(field).trim() !== '';
        }) && 
        Object.values(f).filter(value => typeof value === 'string').every(value => String(value).trim() !== '');
        
        setIsValid(!allFieldsFilled);

        if (store["section"] !== "company") {
            validateRevenue(f, allFieldsFilled)
        }
    };

    const validateRevenue = (f, status) => {
        if(status && f["revenue"] && (f["revenue"]["nMAB"] || f["revenue"]["nMAW"] || f["revenue"]["nMAD"])){
            setError("");
            setIsValid(false);
        } else {
            setError("Recuerde que debe completar al menos un campo de Revenue.");
            setIsValid(true);
        }
    };

    const selected = (data) => {
        const s = data.selectedRows.length > 0 ? data.selectedRows[0]['uuid'] : '';
        setAddPartner(s)
        s ? setIsValid(false) : setIsValid(true)
    };

    const onHandleSearch = (key1, key2, e) => {
        let f = form;
        let value = e.target.value;

        if(f['filters']['type'] === 'email'){
            value = value.trim();
        }

        if(key2 && value){
            f['filters'][key1] ? f['filters'][key1][key2] = value : f['filters'][key1] = {[key2]: value};
        } else if(key1 && value){
            f['filters'][key1] = value;
        } else if(key1 && !value){
            delete f['filters'][key1];
        }
        validateFilterForm(f)
        setForm(JSON.parse(JSON.stringify(f)));
    };

    const validateFilterForm = (f) => {
        if(f['filters']['keyword'] && f['filters']['type']) {
            setIsValidFilter(false)
        } else {
            setIsValidFilter(true)
        }
    };
        
    const handlePageChange = (newPage) => {
        setPage(newPage);
        getData(newPage, perPage, form);
    };
    const handlePerRowsChange = async (newPerPage, newPage) => {
        setPage(newPage);
        setPerPage(newPerPage);
        getData(newPage, newPerPage, form);
    };
    const reset = () => {
        setPage(1);
        getData(1, perPage, form);
    };
    const cleanForm = () => {
        setTabActive('create');
        setNewRegister({});
        setData([]);
        setAddPartner('');
        setIsValid(true);
        setIsValidFilter(true);
        setForm({
            filters: {},
            pagination: {
                page_number: 1,
                results_per_page: 10,
            }
        });
    };

    const clearInput = () => {
        let f = form;
        delete form['filters']['keyword'];
        delete form['filters']['type'];
        setForm(JSON.parse(JSON.stringify(f)));
    };

    useEffect(() => {
        crmService.current = new CrmService(changeAlert);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const calculateColumns = useMemo(() => {
        const columns = []
        store['section'] === 'contact' ?
        columns.push(
            { selector: (row) => row.general.company_name || 'Sin nombre', name: 'Nombre de la Empresa', wrap: true, sortable: true },
        ) :
        columns.push(
            { selector: (row) => row.general.gname + ' ' + row.general.lname, name: 'Nombre', wrap: true, sortable: true },
        )
        return columns
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [store['section']]);

    return {
        data,
        form,
        columns: calculateColumns,
        loading,
        page,
        perPage,
        totalRows,
        tabActive,
        tabs,
        zPos,
        isValidFilter,
        isValid,
        newRegister,
        error,
        getData,
        saveData,
        storeData,
        crmFilter,
        onHandleChange,
        onHandleSearch,
        handlePageChange,
        handlePerRowsChange,
        changeTab,
        reset,
        cleanForm,
        onCreate,
        onUpdate,
        selected,
        clearInput
    };
};
